<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title">The <strong>Digital SLR</strong> Expert</h1>
<h1 class="title1">LANDSCAPES</h1>
<p class="nonindent"><em>essential advice from top pros</em></p>
<p class="extract">TOM MACKIE • WILLIAM NEILL • DAVID NOTON • DARWIN WIGGETT • TONY WOROBIEC</p>
<p class="extract">Edited by Cathy Joseph</p>
<p class="extract"><img alt="" src="OEBPS/images/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781446352496_epub_tp.vue?7a0a4f72